export default function Heading({children}) {

    return (
        <h1 className="test__heading">
            {children}
        </h1>
    );
}